export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_23-4062cf131e45dfd2b739674519f66dad.jpg";